import { ATBInfo } from '@/services/ATBInfo'
import { Registration } from '@/services/Registration'

export class AtbInfoService {
  getByTrackingNumber (trackingNumber: number): Promise<ATBInfo> {
    return new Promise<ATBInfo>((resolve, reject) => {
      fetch(`/api/atbInfo/${trackingNumber}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          resolve(response.json())
        })
        .catch(e => {
          reject(e.statusText)
        })
    })
  }

  getByExportReference (exportReference: string): Promise<ATBInfo> {
    return new Promise<ATBInfo>((resolve, reject) => {
      fetch(`/api/atbInfo/exportReference/${exportReference}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          resolve(response.json())
        })
        .catch(e => {
          reject(e.statusText)
        })
    })
  }

  registerForPickup (registration: Registration, csrfHeader: string, csrfToken: string): Promise<void> {
    const headers = new Headers({
      'Content-Type': 'application/json'
    })

    if (csrfHeader && csrfToken) {
      headers.append(csrfHeader, csrfToken)
    }

    return new Promise((resolve, reject) => {
      fetch('/api/pickup', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(registration)
      }).then(result => {
        if (result.status >= 200 && result.status < 300) {
          resolve()
        } else if (result.status === 400) {
          reject(new Error('invalid-email'))
        } else {
          reject(new Error('generic-error'))
        }
      }).catch(() => {
        reject(new Error('generic-error'))
      })
    })
  }
}

export const atbInfoService = new AtbInfoService()
